import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UtilsService } from 'src/app/Services/utils.service';

@Component({
  selector: 'app-admissionv2',
  templateUrl: './admissionv2.component.html',
  styleUrls: ['./admissionv2.component.scss']
})
export class Admissionv2Component implements OnInit {
  browserDomain: string = window.location.hostname;

  constructor(private router: Router, private util: UtilsService) { }

  ngOnInit() {
    if(!this.browserDomain.includes('extramarks')){
      let hostName = window.location.hostname;
      let domainParts = hostName.split('.');
      let extractedDomain = domainParts.length > 2 ? domainParts.slice(1).join('.') : hostName;
      if(!(extractedDomain === 'oderp.in' || extractedDomain === 'odpay.in'))
      {
          window.open(this.util.loginUrl, "_blank");
          return;
      }
      let path = environment.reactConfig.admission.path || '';
      let redirectUrl = environment.reactConfig.admission.host + extractedDomain + path;
      
      const entity = localStorage.getItem('entityId') || '';
      const session = localStorage.getItem('session') || '';
      redirectUrl += `${path.includes('?') ? '&' : '?'}entity=${entity}&session=${session}`;
      
      const lastTime = sessionStorage.getItem('admissionRedirectTime');
      const now = Date.now();
      const isCooldown = lastTime && (now - parseInt(lastTime)) < 2000;
      
      if(!sessionStorage.getItem('admissionRedirect') || !isCooldown) {
        sessionStorage.setItem('admissionRedirect', 'true');
        sessionStorage.setItem('admissionRedirectTime', now.toString());
        window.open(redirectUrl, "_blank");
        setTimeout(() => {
          sessionStorage.removeItem('admissionRedirect');
          sessionStorage.removeItem('admissionRedirectTime');
        }, 2000);
      }
      
      setTimeout(() => {
        this.router.navigate(['/entity/dashboard']);
      }, 50);
    }
  }
}
